// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1QgqE","rootCenter":"LoadMoreObserver_rootCenter__2LaAc","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__JfsZb"};